import { useEffect, DependencyList } from "react";

const useEffectAsync = (effectFunction: () => Promise<void>, dependencies: DependencyList) => {
    useEffect(() => {
        (async () => await effectFunction())();
    }, dependencies);
};

export default useEffectAsync;